import React, { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import FPTextEditor from 'UI/components/molecules/FPTextEditor';
import { tinymceConfig } from 'UI/constants/config';
import { UIStatus } from 'UI/constants/status';

const DEFAULT_ERROR_TEXT = 'Failed to load template.';

export const TemplateEditor = ({
  apiVersion = 1,
  disabled = false,
  editorConfig = tinymceConfig,
  endpoint,
  name,
  templateId
}) => {
  const { control, errors } = useFormContext();
  const { state } = useFetchWithStatusV2({ endpoint, apiVersion });

  const templateErrorText =
    state.status === UIStatus.Error ? state.error || DEFAULT_ERROR_TEXT : '';

  const templateHtml = useMemo(() => {
    if (!Array.isArray(state.results)) return '';
    const template = state.results.find(item => item?.id === templateId);
    return template?.html || '';
  }, [state.results, templateId]);

  if (state.status === UIStatus.Loading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight={120}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={templateHtml}
      as={
        <FPTextEditor
          config={editorConfig}
          disabled={disabled}
          error={!!errors[name] || !!templateErrorText}
          errorText={errors[name]?.message || templateErrorText}
        />
      }
      onChange={([value]) => value}
      onChangeName="onChange"
      valueName="value"
    />
  );
};
